import { UPDATE_LEGACY_LOANS_DATA } from '@/store/modules/legacyLoansData/routines'

export default {
  [UPDATE_LEGACY_LOANS_DATA](context, payload) {
    context.commit(UPDATE_LEGACY_LOANS_DATA, payload)
  }
}
